<template>
  <div>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step
          color="amber"
          :complete="e1 > 1"
          :step="1"
          @click="e1 = 1"
          >Tab</v-stepper-step
        >
        <v-divider></v-divider>

      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content :step="1">
          <v-row>
            <v-col cols="3">
              <v-btn :to="{ name: 'PictosAdd' }">Add Sign</v-btn>
            </v-col>
            <v-col cols="9">
              <router-view></router-view>
              <pre>
              {{ returnRoute }}
            </pre
              >
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="mb-4">
              <h2 v-text="$t('exercise_pictos.step1.title')"></h2>
              <p
                v-for="(item, index) in $t('exercise_pictos.step1.description')"
                :key="index"
                v-text="item"
              />
            </v-col>
          </v-row>

          <v-row dense class="mb-10">
            <v-expansion-panels :multiple="true">
              <v-expansion-panel
                v-for="(stage, i) in stageCategories"
                :key="`stage${i}`"
              >
                <v-expansion-panel-header>{{ stage }}</v-expansion-panel-header>

                <pictos-tray :items="getSigns(stage)" :stage="stage"></pictos-tray>

                
                
                <v-expansion-panel-content> </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>

          <bottom-navigation
            :save="true"
            :next="false"
            :prev="false"
            :gridView="false"
            :gridToggle="false"
            @save="saveExercise"
            @prev="prevStep"
            @next="nextStep"
          >
          </bottom-navigation>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title
          class="headline"
          v-text="$t('exercise_pictos.saved.title')"
        ></v-card-title>

        <v-card-text
          v-text="$t('exercise_pictos.saved.description')"
        ></v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn
            color="amber accent-1"
            text
            :to="`/users/project/${this.$route.params.id}`"
          >
            Back to Project
          </v-btn>
          <v-btn color="amber accent-1" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { PictosTray } from "./pictos";

// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
export default {
  name: "UserPictos",
  data() {
    return {
      pictos: [],
      signs: [],
      collection: fb.pictosCollection,
      returnRoute: "UserPictos",
      formatCategories: ["Info", "Totem", "A2", "A3", "Email", "Web", "Social"],
      stageCategories: ["Planning", "Arrival", "Orient", "Explore", "Leave"],
      e1: 1,
      dialog: false,
      exercise: null,
      componentReady: false,
      intervalId: null,
      planning: [],
      arrival: [],
      orient: [],
      explore: [],
      exit: [],
    };
  },
  components: {
    BottomNavigation,
    PictosTray
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  beforeRouteUpdate(to, from, next) {
    this.init();
    next();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getExercise();
      this.loadSigns();
    },
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    getSigns(filter) {
      let f = this.signs.filter((item) => item.stage == filter);
      // return lodash.groupBy(f, "physical");
      return f;
    },
    loadSigns() {
      console.log("load signs");
      fb.signsCollection
        .get()
        .then((docs) => {
          let items = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            items.push(doc);
          });
          this.signs = items;
        })
        .catch(() => {});
    },
    getExercise() {
      console.log("get exercise");
      let ref = fb.pictosExCollection.where(
        "uid",
        "==",
        `${this.currentUser.uid}`
      ).where("pid", "==", this.currentProjectModel.id);
      ref
        .get()
        .then((docs) => {
          let items = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            items.push(doc);
          });
          if (items.length) {
            this.exercise = items[0];
          }
        })
        .catch((error) => {
          console.log("no document", error);
        });
    },
    saveExercise(notify) {
      // check if exercise exists
      let ref;
      let vm = this;
      if (this.exercise == null) {
        ref = fb.pictosExCollection.doc();
      } else {
        ref = fb.pictosExCollection.doc(this.exercise.id);
      }
      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: this.currentUser.uid,
          pid: this.currentProjectModel.id,
        })
        .then(() => {
          if (notify) {
            vm.dialog = true;
          }
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    editItem(id) {
      console.log(id);
    }
  },
};
</script>
